import React, { FC } from 'react';
import { BulkCreateFinancialsProps } from './BulkCreateFinancialsProps';

import { returnColumnGroupingModel } from '../BulkEditFinancialsTable/utils';
import Box from '@mui/material/Box';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import useTranslation from '../../hooks/useTranslation';
import { infoGroup, returnColumns } from './utils';
import skapaColours from '@ingka/variables/colours-css';

const BulkCreateFinancials: FC<BulkCreateFinancialsProps> = ({
  projects,
  range,
  onChange,
}) => {
  const t = useTranslation();

  const columns = returnColumns(range, t, onChange);
  return (
    <Box position="relative" mt={2}>
      <Box pdata-testid="ppm-project-bulk" sx={{ height: '60vh' }}>
        <DataGridPremium
          disableColumnPinning={false}
          rowHeight={60}
          sx={{
            '.short-dt-inputs': {
              input: {
                width: '100%',
              },
            },
            border: 0,
            '.MuiDataGrid-columnHeaderTitle': {
              color: skapaColours.colourNeutral6,
            },
            '.number-column-error .input-field__border': {
              borderColor: skapaColours.colourCommercialMessageBtiRed,
              borderWidth: '2px',
            },

            '.MuiDataGrid-columnHeader--filledGroup': {
              height: '30px !important',
              textAlign: 'center',
              fontWeight: 'bold',
              '.MuiDataGrid-columnHeaderTitleContainer': {
                justifyContent: 'center',
              },
              '.MuiDataGrid-columnHeaderTitle': {
                alignSelf: 'center',
                fontWeight: 'bold',
              },
            },
            '.MuiDataGrid-columnHeader--emptyGroup': {
              height: '30px !important',
            },

            '.header-cyan': {
              backgroundColor: 'rgba(140, 221, 255, 1)',
            },
            '.header-blue': {
              backgroundColor: 'rgba(0, 150, 210, 1)',
            },
            '.words-break .MuiDataGrid-columnHeaderTitle': {
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              lineHeight: 1,
              textAlign: 'center',
              fontSize: '12px',
            },
            '.bulk-table-error': {
              color: `${skapaColours.colourCommercialMessageBtiRed} !important`,
              '& .select__border ,.validation-border': {
                border: `1px solid ${skapaColours.colourCommercialMessageBtiRed}`,
              },
            },
          }}
          disableColumnMenu
          disableRowSelectionOnClick
          classes={{
            columnHeader: 'words-break',
          }}
          columnGroupingModel={returnColumnGroupingModel(range, infoGroup)}
          columns={columns as GridColDef[]}
          rows={projects}
        />
      </Box>
    </Box>
  );
};

export default BulkCreateFinancials;
